<template>
    <el-drawer
        :title="`${item.id?'编辑':'新增'}发帖`"
        :visible.sync="show"
        :wrapperClosable="false"
        direction="rtl"
        size="800px"
        :before-close="close">
        <el-form ref="form" :model="form" label-width="80px">
            <el-form-item label="标题" v-check="{'必填': !form.title}">
                <el-input v-model="form.title"></el-input>
            </el-form-item>

            <el-form-item label="内容">
                <div class="panel fx-g1">
                    <vue-neditor-wrap v-model="form.content" :config="myConfig" :destroy="false" ></vue-neditor-wrap>
                </div>
            </el-form-item>
            <el-form-item label="备课">
                <el-select v-model="form.lessonId" placeholder="请选择备课">
                    <el-option
                        v-for="item in lessonOptions"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="代码库">
                <el-select v-model="form.codeBaseId" placeholder="请选择代码库">
                    <el-option
                        v-for="item in codeBaseOptions"
                        :key="item.id"
                        :label="item.title"
                        :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <span  class="fx fx-center">
                <el-button type="primary" @click="sub()">确 定</el-button>
                <el-button @click="close()">关 闭</el-button>
            </span>
        </el-form>

    </el-drawer>

</template>


<style scoped>
.fx-c_stretch .pic_item {
    width: 40%;
    height: 200px;
    border-radius: 10px;
    overflow: hidden;
    margin-bottom: 30px;
    position: relative;
}
.pic_item img {
    width: 100%;
    height: 100%;
}
.fx-c_stretch .del_btn {
    display: inline-block;
    position: absolute;
    top: 10px;
    right: 10px;
    cursor: pointer;
    font-size: 30px;
    color: rgb(22, 21, 21);
}
.del_btn:hover {
    color: var(--primary);
}
.upload_btn {
    border: 1px dashed var(--primary);
    border-radius: 10px;
    cursor: pointer;
}
</style>
<script>

import VueNeditorWrap from 'vue-neditor-wrap'

export default {
    props: [
        "item",
    ],
    components: {
        VueNeditorWrap
    },
    data() {
        return {
            show: false,
            uploading: false,
            form: {...this.item,list:[]},
            lessonOptions: {},
            codeBaseOptions: {},
            needRefreshParent: false,
            myConfig: {
                // 如果需要上传功能,找后端小伙伴要服务器接口地址
                serverUrl: '/api/web/upload/ueditor',
                UEDITOR_HOME_URL: '/admin/NEditor/',
                // 编辑器不自动被内容撑高
                autoHeightEnabled: false,
                // 初始容器高度
                initialFrameHeight: 400,
                // 初始容器宽度
                initialFrameWidth: '100%',
                // 关闭自动保存
                enableAutoSave: true,
                maximumWords:2000
            },
        }

    },


    methods: {
        close() {
            if (this.needRefreshParent) {
                this.$emit("submit");
            } else {
                this.$emit("close");
            }
        },
        sub() {
            this.$checkForm(this.$refs.form).then(success => {
                if (success) {
                    this.$ajaxPost("/posts/save", {
                        posts: this.form,
                    }, data => {
                        this.$showSuccess("保存成功", 1200, ()=> {
                            this.needRefreshParent = true;
                            this.$emit("submit", data.result);
                            this.$emit("close");
                        })
                    })
                    return false;
                } else {
                    this.$showError("请输入内容再保存");
                }
            })
        },
        loadLessons() {
            this.$ajaxPost("/lesson/listByPrepare",{form:{keywords:""},pager:null}, (data) => {
                this.lessonOptions = data.result;
            })
        },
        loadCodeBases() {
            this.$ajaxPost("/codeBase/list", {form:{keywords:""},pager:null}, (data) => {
                this.codeBaseOptions = data.result;
            })
        },
    },
    mounted() {
        this.show = true;
    },
    created() {
        if(this.form.id == undefined){//新增 内容清空
            this.form.content = "";
        }
        this.loadCodeBases();
        this.loadLessons();
    }


}
</script>
